"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Control = void 0;
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var Renderer_1 = require("./Renderer");
/**
 * A controlled component convenience wrapper that additionally manages a focused state.
 *
 * @template P control specific properties
 * @template S the state managed by the control
 */
var Control = /** @class */ (function (_super) {
    tslib_1.__extends(Control, _super);
    function Control(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Propagates a value change.
         *
         * @param value the updated value
         */
        _this.handleChange = function (value) {
            _this.setState({ value: value });
            _this.updateData(value);
        };
        /**
         * Set the focused state to true.
         */
        _this.onFocus = function () {
            _this.setState({ isFocused: true });
        };
        /**
         * Set the focused state to false.
         */
        _this.onBlur = function () {
            _this.setState({ isFocused: false });
        };
        _this.updateData = function (value) {
            _this.props.handleChange(_this.props.path, value);
        };
        // tslint:disable:no-object-literal-type-assertion
        _this.state = {
            value: props.data ? props.data : '',
            isFocused: false
        };
        return _this;
        // tslint:enable:no-object-literal-type-assertion
    }
    return Control;
}(Renderer_1.RendererComponent));
exports.Control = Control;
//# sourceMappingURL=Control.js.map